
import React from 'react';
import { WeatherCondition } from '@/types/weather';
import {
  CloudSun,
  Cloud,
  CloudRain,
  CloudDrizzle,
  CloudLightning,
  Snowflake,
  CloudFog,
  Wind,
  AlertTriangle,
  Sun
} from 'lucide-react';

export type IconSize = "sm" | "md" | "lg";

export const getIconSize = (size: IconSize): string => {
  // Increase all sizes by 45%
  switch (size) {
    case "sm":
      return "w-14 h-14"; // Original was around w-10 h-10, increased by 45%
    case "md":
      return "w-20 h-20"; // Original was around w-14 h-14, increased by 45%
    case "lg":
      return "w-36 h-36"; // Original was around w-24 h-24, increased by 45%
    default:
      return "w-36 h-36";
  }
};

export const getWeatherIcon = (condition: WeatherCondition, sizeClass: string) => {
  const iconProps = {
    className: `${sizeClass} stroke-1`,
    strokeWidth: 1.5
  };

  switch (condition) {
    case 'clear':
      return <Sun {...iconProps} className={`${sizeClass} stroke-1 text-amber-500`} />;
    case 'partlyCloudy':
      return <CloudSun {...iconProps} className={`${sizeClass} stroke-1 text-blue-400`} />;
    case 'cloudy':
      return <Cloud {...iconProps} className={`${sizeClass} stroke-1 text-slate-500`} />;
    case 'rain':
      return <CloudRain {...iconProps} className={`${sizeClass} stroke-1 text-cyan-500`} />;
    case 'heavyRain':
      return <CloudDrizzle {...iconProps} className={`${sizeClass} stroke-1 text-blue-600`} />;
    case 'thunderstorm':
      return <CloudLightning {...iconProps} className={`${sizeClass} stroke-1 text-indigo-500`} />;
    case 'snow':
      return <Snowflake {...iconProps} className={`${sizeClass} stroke-1 text-blue-300`} />;
    case 'fog':
      return <CloudFog {...iconProps} className={`${sizeClass} stroke-1 text-gray-400`} />;
    case 'wind':
      return <Wind {...iconProps} className={`${sizeClass} stroke-1 text-teal-500`} />;
    case 'alert':
      return <AlertTriangle {...iconProps} className={`${sizeClass} stroke-1 text-red-500`} />;
    default:
      return <Cloud {...iconProps} className={`${sizeClass} stroke-1 text-slate-500`} />;
  }
};
